module.exports = __webpack_public_path__ + "assets/webgl/wp_not_ready_yet_color.jpg.809c75a7.webp";